import React, { useState, useEffect } from 'react';
import SaleFooter from '../Partials/SaleFooter/SaleFooter';
import { connect } from 'react-redux';
import { goToPage, setIsSubmit, reportDWH, setPersonalInfo, reportAnalytics } from '../saleJetBlockSlice';
import { createLead } from '../saleBlockAsyncThunk';
import LeadForm from '../Partials/LeadForm/LeadForm';
import WhatsApp from '../Partials/WhatsApp/WhatsApp';
import LeadSuccess from '../Partials/LeadSuccess/LeadSuccess';
import EpiContext from '@episerver/spa-core/Spa';
import Config from '../../../../Config';
import { gtag4 } from '../../../../utilities/analytics/tracking';

const LegacyLeadPage = (props) => {
    const [step, setStep] = useState(props.isWhatsAppActive ? 'WhatsApp' : 'LeadForm');
    const env_num = props.headerData?.tabIndex;
    const [envType, setEnvType] = useState('init');
    useEffect(() => {
        if (env_num == 0) setEnvType('private');
        if (env_num == 1) setEnvType('buisness');
    }, [env_num]);
    useEffect(() => {
        if (step == 'WhatsApp') {
            if (props.leadType == "noFiber") {
                if (props.isWhatsAppActive) {
                    gtag4({
                      event: `${props.saleType}_Step3_NoSivimWhatsappPage`,
                      step: '3',
                      action: 'NoSivimWhatsappPage',
                      funnel_name: 'No_Sivim',
                    });
                } else {
                  gtag4({
                    event: `${props.saleType}_Step4_LeadPage`,
                    step: '4',
                    action: 'LeadPage',
                    funnel_name: 'No_Sivim',
                  });
                }
            }
            props.reportDWH({ actionType: 'Get Customer Info', status: 'Ongoing', messageText: 'No Fiber - Whatsapp Display' });
        }
        else {
            props.reportDWH({ actionType: 'Get Customer Info', status: 'Ongoing', messageText: 'No Fiber- Lead Form Display' });
            gtag4({
                event: `${props.saleType}_Step3_LeadPage`,
                step: '3',
                action: 'LeadPage',
                funnel_name: 'No_Sivim'
            });
        }
    }, []);
    //page params
    let isDisplayFooter = false;
    let isDisplayWhatsAppIcon = (props.isWhatsAppActive && step == 'WhatsApp');
    let btnText = '';
    let currentPageFunction = handlePageContinue;
    let totalPrice = null;
    let priceText = '';
    let formid = 'saleJet';
    let bottomLink = null;
    //page params
    if (props.isWhatsAppActive) {
        if (step == 'WhatsApp') {
            bottomLink = { text: 'שנציג יחזור אלי', onclick: handleLeadFormClick };
        }
        else {
            bottomLink = { text: 'בא לי Whatsapp', onclick: handleWhatsAppClick };
        }
    }
    let title = '';
    let subTitle = '';
    if (step == 'LeadForm') {
        switch (props.leadType) {
            case 'differentAddress':
                title = <> כתובת זו אינה תואמת לכתובת שעודכנה בתחילת התהליך </>;
                subTitle = <> נשמח לחזור אליך בהקדם ולספר לך עוד </>;
                break;
            case 'noFiber':
                if (props.isWhatsAppActive) {
                    title = <> אני רוצה שתחזרו אליי </>;
                }
                else {
                    title = <> הסיב שלנו יגיע בקרוב עד אליך </>;
                    subTitle = <> כמה פרטים, ונעדכן אותך מיד כשזה יקרה. </>;
                }
                break;
            case 'hasCopper':
                title = <> אתה מחובר לתשתית ישנה </>;
                subTitle = <> נשמח לחזור אליך בהקדם ולספר לך עוד </>;
                break;
            case 'hasMapa':
                title = <> בחרת להתקדם עם מנוי שיש בו קו טלפון ביתי </>;
                subTitle = <> נשמח לחזור אליך בהקדם ולספר לך עוד </>;
                break;
            case 'hasTvAndInternet':
                title = <> השירותים שלנו כבר קיימים בכתובת שבחרת </>;
                subTitle = <> נשמח לחזור אליך בהקדם ולספר לך עוד </>;
                break;
            case 'superWifiLead':
                title = <> בחרת להתקדם ללא סופר WiFi </>;
                subTitle = <> נשמח לחזור אליך בהקדם ולספר לך עוד </>;
                break;
        }
    }
    let currentPageHeadline = (
        <div className='page-headline-wrapper'>
            {title && <h1 className='sale-title-big'> {title} </h1>}
            {subTitle && <h2 className='sale-title-small'> {subTitle} </h2>}
        </div>
    );
    const getStep = () => {
        switch (step) {
            case 'LeadForm':
                isDisplayFooter = true;
                btnText = 'תחזרו אלי';
                if (props.saleType == 'triple') {
                    props.reportAnalytics({
                        eventCategory: 'fibertv_process',
                        eventAction: 'address_without_sivim',
                        eventLabel: 'address_without_sivim',
                    });
                } else if (props.saleType == 'internet') {
                    props.reportAnalytics({
                        eventCategory: 'sivim_process',
                        eventAction: 'address_without_sivim',
                        eventLabel: 'address_without_sivim',
                    });
                }
                return <LeadForm onSubmit={props.isSubmit} onValid={handlePageValidate} />;
            case 'LeadSuccess':
                btnText = 'חזרה לעמוד הראשי';
                isDisplayFooter = true;
                bottomLink = null;

                gtag4({
                  event: `${props.saleType}_Step5_LeadSent`,
                  step: '5',
                  action: 'LeadSent',
                  funnel_name: 'No_Sivim',
                });

                if (props.saleType == 'triple') {
                    props.reportAnalytics({ eventCategory: 'fibertv_process', eventAction: 'lead_submit', eventLabel: 'lead_submit' });
                } else if (props.saleType == 'internet') {
                    props.reportAnalytics({ eventCategory: 'sivim_process', eventAction: 'lead_submit', eventLabel: 'lead_submit' });
                }
                if (props.isWhatsAppActive) {
                    props.reportDWH({ actionType: 'Get Customer Info', status: 'Ongoing', messageText: 'No Fiber - Sent Lead Form on Service Time' });
                } else {
                    props.reportDWH({ actionType: 'Get Customer Info', status: 'Ongoing', messageText: 'No Fiber - Sent Lead Form' });
                }
                return <LeadSuccess onSubmit={props.isSubmit} onValid={handlePageValidate} lead_type={envType} form_list={''} />;
            case 'WhatsApp':
                btnText = 'נמשיך ב-WhatsApp';
                isDisplayFooter = true;
                currentPageFunction = handleOpenWhatsApp;
                return <WhatsApp />;
        }
    };
    let currentPageView = <div>{getStep()}</div>;
    return (
        <div className='slideAnimation'>
            {currentPageHeadline}
            <div className='sale-page-content'>
                <form noValidate id='sale' onSubmit={handleSubmit}>
                    {currentPageView}
                </form>
                <SaleFooter isDisplayFooter={isDisplayFooter} btnText={btnText} onclick={currentPageFunction} price={totalPrice} priceText={priceText} formid={formid} bottomLink={bottomLink} isDisplayWhatsAppIcon={isDisplayWhatsAppIcon} />
            </div>
        </div>
    );
    async function handlePageValidate(data) {
        props.setIsSubmit(false);
        switch (step) {
            case 'LeadForm':
                if (data.isValid) {
                    if (props.isWhatsAppActive) {
                        gtag4({
                            event: `${props.saleType}_Step4_LeadButton`,
                            step: '4',
                            button: btnText,
                            action: 'LeadButton',
                            funnel_name: 'No_Sivim'
                        });
                    }
                    props.reportDWH({ actionType: 'Get Customer Info', status: 'Ongoing', messageText: 'Customer Info Sent' });
                    gtag4({
                        event: `${props.saleType}_Step3_LeadFormButton`,
                        button: btnText,
                        action: 'LeadFormButton',
                        funnel_name: 'No_Sivim'
                    });
                    props.setPersonalInfo({ firstName: data.data.firstName, lastName: data.data.lastName, subscriberNo: data.data.phoneNumber });
                    let createLead = await props.createLead();
                    if (createLead?.payload?.Body?.isSuccess) {
                        setStep('LeadSuccess');

                    }
                }
                break;
            case 'LeadSuccess':
                gtag4({
                    event: `${props.saleType}_Step5_HpButton`,
                    step: '5',
                    button: btnText,
                    action: 'HpButton',
                    funnel_name: 'No_Sivim',
                });
                EpiContext.navigateTo(EpiContext.getSpaBasePath());
                break;
        }
    }
    function handlePageContinue() {
        props.setIsSubmit(true);
    }
    function handleOpenWhatsApp() {
        props.reportDWH({ actionType: 'Get Customer Info', status: 'Ongoing', messageText: 'No Fiber - Open Whatsapp Clicked From Form' });
        gtag4({
            event: `${props.saleType}_Step3_WhatsappClick`,
            step: '3',
            button: 'בא לי Whatsapp',
            action: 'WhatsappClick',
            funnel_name: 'No_Sivim',
        });
        const whatsAppLink = `https://wa.me/${Config.whatsAppSale}?force_isolation=true&text=%D7%A0%D7%A9%D7%9E%D7%97+%D7%9C%D7%A7%D7%97%D7%AA+%D7%90%D7%AA+%D7%96%D7%94+%D7%94%D7%9C%D7%90%D7%94+%2C%D7%A8%D7%A7+%D7%9C%D7%A4%D7%A0%D7%99+%D7%9B%D7%9F+%D7%A0%D7%95%D7%95%D7%93%D7%90+%D7%A9%D7%96%D7%95+%D7%94%D7%9B%D7%AA%D7%95%D7%91%D7%AA+%D7%94%D7%A0%D7%9B%D7%95%D7%A0%D7%94+%D7%9C%D7%91%D7%93%D7%99%D7%A7%D7%AA+%D7%94%D7%A1%D7%99%D7%91%D7%99%D7%9D%3A+%D7%A8%D7%97%D7%95%D7%91+${props.selectedAddress.streetName}+%D7%9E%D7%A1+${props.selectedAddress.home}+%D7%93%D7%99%D7%A8%D7%94+${props.selectedAddress.apartment}+%D7%A2%D7%99%D7%A8+${props.selectedAddress.cityName}.+%D7%94%D7%A7%D7%9C%D7%99%D7%A7%D7%95+%D7%A9%D7%9C%D7%97`;
        let win = window.open(whatsAppLink, '_blank');
        win.focus();
    }
    function handleLeadFormClick(event) {
        event.preventDefault();
        props.reportDWH({ actionType: 'Get Customer Info', status: 'Ongoing', messageText: 'No Fiber - Open Lead Form' });
        gtag4({
            event: `${props.saleType}_Step3_RepClick`,
            step: '3',
            button: 'שנציג יחזור אלי',
            action: 'RepClick',
            funnel_name: 'No_Sivim',
        });
        setStep('LeadForm');
    }
    function handleWhatsAppClick(event) {
        event.preventDefault();
        props.reportDWH({ actionType: 'Get Customer Info', status: 'Ongoing', messageText: 'No Fiber - Whatsapp Clicked' });
        gtag4({
            event: `${props.saleType}_Step4_WhatsappCallClick`,
            step: '4',
            button: 'בא לי Whatsapp',
            action: 'WhatsappCallClick',
            funnel_name: 'No_Sivim',
        });
        setStep('WhatsApp');
    }
    function handleSubmit(event) {
        event.preventDefault();
    }
};

const mapStateToProps = (state) => {
    return {
        saleType: state.saleJetBlock.saleType,
        flowType: state.saleJetBlock.flowType,
        isSubmit: state.saleJetBlock.isSubmit,
        leadType: state.saleJetBlock.leadType,
        headerData: state.Header,
        isWhatsAppActive: state.saleJetBlock.isWhatsAppActive,
        selectedAddress: state.saleJetBlock.addressPage.selectedAddress,
    };
};

const mapDispatchToProps = {
    goToPage,
    setIsSubmit,
    reportDWH,
    setPersonalInfo,
    createLead,
    reportAnalytics,
};

export default connect(mapStateToProps, mapDispatchToProps)(LegacyLeadPage);
